// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__fXy8z","modal":"Modal_modal__G9FtB","slide-down":"Modal_slide-down__vegWf"};